import {chain, without} from 'lodash';

import {collapseByUid} from '../../../models/api/dataGroupModel';
import {MessageVisualStatusesEnum} from '../../../models/api/messageModel';
import {AppAction} from '../../appActions';
import {CommentsActionsEnum} from '../comments/commentsActions';
import {DataGroupsActionsEnum} from '../dataGroupsActions';
import {MessageActionsEnum} from '../messages/messagesActions';
import {OfflineActionsEnum} from './offlineActions';

export function offlineDraftMessageUidsReducer(state: ReadonlyArray<string>, action: AppAction) {
  switch (action.type) {
    case DataGroupsActionsEnum.DATA_UPDATED: {
      const {messages} = action.payload.result;
      if (!messages || messages.length === 0) {
        return state;
      }

      const collapsedMessages = collapseByUid(messages);
      const savingMessageUids = chain(collapsedMessages)
        .map((m) => m.visualStatus === MessageVisualStatusesEnum.DRAFT && m)
        .compact()
        .filter((m) => m.isSaving)
        .map((m) => m.uid)
        .value();

      const notSavingMessageUids = chain(collapsedMessages)
        .filter((m) => m.visualStatus !== MessageVisualStatusesEnum.DRAFT || !m.isSaving)
        .map((m) => m.uid)
        .value();

      return chain(state).concat(savingMessageUids).difference(notSavingMessageUids).uniq().value();
    }

    case MessageActionsEnum.MESSAGE_DELETED:
      return without(state, action.payload.messageUid);

    case OfflineActionsEnum.CLEAR_OFFLINE_DRAFTS:
      return [];

    default:
      return state;
  }
}

export function offlineDraftCommentUidsReducer(state: ReadonlyArray<string>, action: AppAction) {
  switch (action.type) {
    case DataGroupsActionsEnum.DATA_UPDATED: {
      const {comments} = action.payload.result;
      if (!comments || comments.length === 0) {
        return state;
      }

      const collapsedComments = collapseByUid(comments);
      const savingCommentUids = chain(collapsedComments)
        .filter((c) => c.isSaving)
        .map((c) => c.uid)
        .value();

      const notSavingCommentUids = chain(collapsedComments)
        .filter((c) => !c.isSaving)
        .map((c) => c.uid)
        .value();

      return chain(state).concat(savingCommentUids).difference(notSavingCommentUids).uniq().value();
    }

    case CommentsActionsEnum.COMMENT_DELETED:
      return without(state, action.payload.commentUid);

    case OfflineActionsEnum.CLEAR_OFFLINE_DRAFTS:
      return [];

    default:
      return state;
  }
}
